module.exports = __webpack_public_path__ + "static/media/brooch_3.15fd0b4a.jpg";